"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Separator } from "@/components/ui/separator";
export default function TermsOfService() {
  const {
    ref: preambleRef,
    isVisible: preambleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: accordionRef,
    isVisible: accordionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const protocols = [{
    number: "01",
    question: "Αποδοχή Όρων Χρήσης",
    paragraphs: ["Με την πρόσβαση στην ιστοσελίδα HotelDeals.gr, συμφωνείτε να δεσμεύεστε από τους παρόντες όρους χρήσης. Εάν δεν συμφωνείτε με οποιονδήποτε από αυτούς τους όρους, παρακαλούμε να μην χρησιμοποιείτε την υπηρεσία μας.", "Διατηρούμε το δικαίωμα να τροποποιούμε τους όρους ανά πάσα στιγμή, με ισχύ από τη στιγμή της δημοσίευσής τους στην ιστοσελίδα."]
  }, {
    number: "02",
    question: "Περιγραφή Υπηρεσιών",
    paragraphs: ["Το HotelDeals.gr λειτουργεί ως πλατφόρμα αναζήτησης και σύγκρισης προσφορών ξενοδοχείων. Δεν είμαστε οι πάροχοι των καταλυμάτων και δεν φέρουμε ευθύνη για τις κρατήσεις που πραγματοποιούνται σε τρίτες ιστοσελίδες.", "Οι πληροφορίες που παρέχονται βασίζονται σε δεδομένα που λαμβάνουμε από τους συνεργάτες μας και καταβάλλουμε κάθε προσπάθεια για την ακρίβειά τους."]
  }, {
    number: "03",
    question: "Πνευματική Ιδιοκτησία",
    paragraphs: ["Όλο το περιεχόμενο της ιστοσελίδας, συμπεριλαμβανομένων των κειμένων, των λογοτύπων και των γραφικών, αποτελεί ιδιοκτησία του HotelDeals.gr ή των συνεργατών μας και προστατεύεται από τη νομοθεσία περί πνευματικής ιδιοκτησίας.", "Απαγορεύεται η αναπαραγωγή ή χρήση του περιεχομένου χωρίς την προηγούμενη έγγραφη άδειά μας."]
  }, {
    number: "04",
    question: "Περιορισμός Ευθύνης",
    paragraphs: ["Το HotelDeals.gr δεν εγγυάται ότι η ιστοσελίδα θα είναι διαθέσιμη χωρίς διακοπές ή σφάλματα. Δεν φέρουμε ευθύνη για οποιαδήποτε άμεση ή έμμεση ζημία προκύψει από τη χρήση της πλατφόρμας.", "Η χρήση των υπηρεσιών μας γίνεται με αποκλειστική ευθύνη του χρήστη."]
  }, {
    number: "05",
    question: "Πολιτική Ακυρώσεων",
    paragraphs: ["Οι πολιτικές ακύρωσης καθορίζονται αποκλειστικά από το εκάστοτε ξενοδοχείο ή τον πάροχο κρατήσεων. Παρακαλούμε να ελέγχετε προσεκτικά τους όρους του παρόχου πριν ολοκληρώσετε την κράτησή σας.", "Για οποιοδήποτε ζήτημα σχετικά με την ακύρωση, θα πρέπει να επικοινωνήσετε απευθείας με το κατάλυμα ή την πλατφόρμα κράτησης."]
  }, {
    number: "06",
    question: "Προσωπικά Δεδομένα",
    paragraphs: ["Η διαχείριση των προσωπικών σας δεδομένων διέπεται από την Πολιτική Απορρήτου μας, η οποία είναι πλήρως εναρμονισμένη με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR).", "Χρησιμοποιούμε τα δεδομένα σας αποκλειστικά για τη βελτίωση της εμπειρίας σας και την παροχή των υπηρεσιών μας."]
  }, {
    number: "07",
    question: "Επικοινωνία",
    paragraphs: ["Για οποιαδήποτε ερώτηση ή διευκρίνιση σχετικά με τους όρους χρήσης, μπορείτε να επικοινωνήσετε μαζί μας μέσω της φόρμας επικοινωνίας στην ιστοσελίδα μας.", "Δεσμευόμαστε να απαντάμε σε όλα τα αιτήματα εντός 48 ωρών κατά τις εργάσιμες ημέρες."]
  }];
  return <section data-section-id="1615" id="όροι-χρήσης-hoteldealsgr" className="relative w-full bg-background text-foreground py-32 md:py-44 overflow-hidden">
      <Separator className="absolute top-0 left-0 right-0 bg-border" />

      <div className="mx-auto max-w-[1440px] px-6 md:px-16 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8">
          {}
          <div ref={preambleRef} className="lg:col-span-5 relative">
            <div className="lg:sticky lg:top-32">
              <div className="relative">
                {}
                <span aria-hidden="true" className="pointer-events-none absolute -right-4 -top-12 md:-top-20 font-default font-thin leading-none select-none text-border/30" style={{
                fontSize: "clamp(10rem, 22vw, 22rem)",
                fontWeight: 100
              }}>
                  07
                </span>

                {}
                <div className={`relative font-mono uppercase text-foreground transition-all duration-700 ease-out ${preambleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
                letterSpacing: "0.18em"
              }}>
                  N° 07 — ΟΡΟΙ ΧΡΗΣΗΣ
                </div>

                {}
                <h2 className={`relative font-default text-foreground mt-12 md:mt-14 transition-all duration-700 ease-out delay-[80ms] ${preambleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                fontSize: "clamp(2.25rem, 4.8vw, 4.75rem)",
                fontWeight: 250,
                letterSpacing: "-0.02em",
                lineHeight: 1.02
              }}>
                  Όροι και <em className="italic font-light">προϋποθέσεις</em> χρήσης.
                </h2>

                {}
                <p className={`relative font-default text-muted-foreground mt-10 max-w-md transition-all duration-700 ease-out delay-[160ms] ${preambleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
                fontWeight: 300,
                letterSpacing: "-005em",
                lineHeight: 1.55
              }}>
                  Οι παρακάτω όροι καθορίζουν το πλαίσιο λειτουργίας του HotelDeals.gr, διασφαλίζοντας μια διαφανή και ασφαλή εμπειρία για όλους τους χρήστες μας.
                </p>

                {}
                <div className={`relative mt-12 font-mono uppercase text-muted-foreground transition-all duration-700 ease-out delay-[240ms] ${preambleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
                letterSpacing: "0.08em"
              }}>
                  ΕΝΗΜΕΡΩΣΗ · ΜΑΡ 2024
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={accordionRef} className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full border-t border-border">
              {protocols.map((item, i) => <AccordionItem data-index={i} key={item.number} value={`item-${item.number}`} className={`border-b border-border last:border-b-0 transition-all duration-700 ease-out ${accordionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: `${i * 60}ms`
            }}>
                  <AccordionTrigger className="group py-8 hover:no-underline rounded-md data-[state=open]:[&_.indicator]:text-accent-foreground">
                    <div className="flex-1 grid grid-cols-12 items-baseline gap-4 pr-4">
                      <div className="col-span-9 md:col-span-9 text-left">
                        <h4 className="font-default text-foreground" style={{
                      fontSize: "clamp(1.125rem, 1.4vw, 1.375rem)",
                      fontWeight: 300,
                      letterSpacing: "0em",
                      lineHeight: 1.3
                    }}>
                          {item.question}
                        </h4>
                      </div>
                      <div className="hidden md:block md:col-span-2 font-mono text-muted-foreground" style={{
                    fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
                    letterSpacing: "0.08em"
                  }}>
                        {item.number}
                      </div>
                      <div className="col-span-3 md:col-span-1 text-right font-mono text-foreground indicator transition-colors duration-300" style={{
                    fontSize: "clamp(0.875rem, 1vw, 1rem)",
                    letterSpacing: "0.05em"
                  }}>
                        <span className="group-data-[state=open]:hidden">+</span>
                        <span className="hidden group-data-[state=open]:inline">
                          —
                        </span>
                      </div>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="pt-0 pb-0">
                    <div className="bg-card py-10 px-0">
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-10 md:col-start-1 space-y-5">
                          {item.paragraphs.map((p, pi) => <p data-index={pi} key={pi} className="font-default text-foreground" style={{
                        fontSize: "clamp(0.9375rem, 1vw, 1rem)",
                        fontWeight: 400,
                        lineHeight: 1.65
                      }}>
                              {p}
                            </p>)}

                          <Separator className="bg-border mt-8" />

                          <Link to="/PrivacyPolicyAndPersonalDataPage" className="inline-block mt-2 font-mono uppercase text-foreground hover:text-accent-foreground transition-colors duration-220" style={{
                        fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
                        letterSpacing: "0.08em",
                        textDecoration: "underline",
                        textUnderlineOffset: "6px"
                      }}>
                            Πολιτική Απορρήτου — Αναλυτικά
                          </Link>
                        </div>
                      </div>
                    </div>
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>

      <Separator className="absolute bottom-0 left-0 right-0 bg-border" />
    </section>;
}